(function() {
    'use strict';
    angular
        .module('nasracApp')
        .controller('ASTBHeadendDialogController', HeadendDialogController);
    HeadendDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Headend', 'Office', 'HeadendManagePricing' ];
    function HeadendDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Headend, Office, HeadendManagePricing) {
        var vm = this;
        vm.headend = entity;
        vm.clear = clear;
        vm.save = save;
        vm.offices = Office.query();
        vm.toggleNctcMember= toggleNctcMember;
        HeadendManagePricing.query().$promise.then(function(data) {
            if(vm.headend.id==null) {
                vm.headend.boxFeeMot = data[0].boxFeeMot;
                vm.headend.boxFeeNonMot = data[0].boxFeeNonMot;
                vm.headend.dtaFee = data[0].dtaFee;
                //vm.headend.minimumFee = 250;
            }
        });

        vm.headendTypeChanged =  function () {
            if(vm.headend.headendType === 'HB')
                vm.headend.minimumFee = 250;
            else if(vm.headend.headendType === 'DL')
                vm.headend.minimumFee = 25;
        };
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        function save () {
            vm.isSaving = true;
            if (vm.headend.id !== null) {
                Headend.update(vm.headend, onSaveSuccess, onSaveError);
            } else {
                Headend.save(vm.headend, onSaveSuccess, onSaveError);
            }
        }
        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:headendUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }
        function onSaveError () {
            vm.isSaving = false;
        }
        function toggleNctcMember(){
            vm.headend.nctcMemberId = "";
            vm.headend.nctcSystemId = "";
        }
    }
})();

